var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01421 11.0813H13.9394L13.9394 26.4324C13.9394 26.7156 14.0518 26.9871 14.252 27.1873C14.4523 27.3875 14.7238 27.5 15.0069 27.5C15.2901 27.5 15.5616 27.3875 15.7618 27.1873C15.9621 26.9871 16.0745 26.7156 16.0745 26.4324V11.0813H20.9855C21.1198 11.0828 21.2515 11.044 21.3634 10.9697C21.4753 10.8954 21.5622 10.7891 21.6129 10.6647C21.6636 10.5403 21.6756 10.4035 21.6475 10.2722C21.6194 10.1408 21.5524 10.021 21.4552 9.92827L15.4767 2.69977C15.4144 2.6365 15.3402 2.58626 15.2583 2.55196C15.1765 2.51766 15.0886 2.5 14.9998 2.5C14.9111 2.5 14.8232 2.51766 14.7413 2.55196C14.6595 2.58626 14.5852 2.6365 14.523 2.69977L8.54447 9.92827C8.44729 10.021 8.38028 10.1408 8.35215 10.2722C8.32402 10.4035 8.33608 10.5403 8.38676 10.6647C8.43744 10.7891 8.52439 10.8954 8.6363 10.9697C8.74821 11.044 8.8799 11.0828 9.01421 11.0813Z",
    fill: "#E8EBEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIcon);
export default __webpack_public_path__ + "static/media/up-arrow-icon.fc752e93ef5241a96386b616c3e6f115.svg";
export { ForwardRef as ReactComponent };